import React, { ReactNode, useState } from 'react';

import { Box } from '@mui/material';

import Header from '../common/Header/Header';
import { Sidebar } from '../Sidebar/Sidebar';

interface PageLayoutProps {
  children: ReactNode;
  isAdmin?: boolean;
  pageId: string;
}

const PageLayout: React.FC<PageLayoutProps> = ({ children, pageId, isAdmin = true }) => {
  const [sidebarWidth, setSidebarWidth] = useState(60); // Default collapsed width

  const handleSidebarResize = (width: number) => {
    setSidebarWidth(width);
  };

  return (
    <Box sx={{ display: 'flex' }}>
      <Sidebar isAdmin={isAdmin} onResize={handleSidebarResize} pageId={pageId} />
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          flexGrow: 1,
          transition: 'margin 0.3s ease',
          marginLeft: `${sidebarWidth}px`,
          width: `calc(100% - ${sidebarWidth}px)`,
        }}
      >
        <Header />
        <Box
          component="main"
          sx={{
            flexGrow: 1,
            p: 3,
          }}
        >
          {children}
        </Box>
      </Box>
    </Box>
  );
};

export default PageLayout;
